import { HomeworkCard } from './HomeworkCard';
export default HomeworkCard;
